import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解6080影院的故事与使命
        </p>
        <div className="rounded-lg border border-background-300/40 bg-background-50/70 p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 text-center max-w-2xl mx-auto">
            {aboutInfo.intro}
          </p>
          <p className="text-center mb-8">
            <span className="inline-block px-5 py-2 text-sm font-medium font-heading text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20">
              <i className="ri-double-quotes-l mr-1"></i>
              {aboutInfo.mission}
              <i className="ri-double-quotes-r ml-1"></i>
            </span>
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutInfo.stats.map((stat, idx) => (
              <div key={idx} className="text-center p-4 rounded-lg bg-background-100/60">
                <div className="text-xl md:text-2xl font-bold font-heading text-primary-400 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}